import PayInvoicesStepper from './PayInvoicesStepper';

export default PayInvoicesStepper;
